import React from 'react';
import styles from '../ScoreRules/ScoreRules.module.css';

const CompetitionSystemsDescription = () => {
    return (
        <div className={styles.scoreRulesContainer}>
            <h1>Systemy rozgrywek w turniejach BTT</h1>

            <div className={styles.scoreRulesText}>

                <h5>1. <i>Każdy z każdym</i></h5>
                <p className={styles.competitionDescription}>W tym systemie każdy uczestnik gra z każdym innym
                    uczestnikiem turnieju. Kolejność meczów jest ustalana według metody Bergera parowania rywali w
                    systemie kołowym.</p>
                <p className={styles.competitionDescription}>Klasyfikacja w tabeli jest określana według
                    następuących
                    kryteriów:</p>
                <li>Liczba wygranych setów,</li>
                <li>Liczba, będąca różnicą pomiędzy gemami wygranymi i przegranymi. Punkty tiebreaka trzeciego seta
                    przeliczane są proporcjonalnie do liczby gemów w secie,
                    np. jeżeli pierwsze dwa sety toczą się do 4 wygranych gemów, to 10 pkt tiebreka przeliczana jest na
                    4 pkt. ,
                </li>
                <li>W przypadku, gdy dwóch graczy posiada równą liczby punktów oraz ten sam wynik, będący różnicą gemów
                    wygranych i przegranych,
                    decyduje bezpośredni wynik meczu pomiędzy tymi graczami.
                </li>

                <h5>2. <i>System pucharowy</i></h5>
                <p className={styles.competitionDescription}>Uczestnicy są eliminowani po każdej przegranej.
                    Turniej trwa, dopóki nie pozostanie jeden zwycięzca. Ponieważ w BTT przyjęliśmy zasadę rozegrania
                    przynamniej dwóch meczów w turnieju, to system ten używany jest głównie jako druga część systemu
                    'Faza grupowa + faza finałowa'.</p>

                <h5>3. <i>Brazylijski do dwóch przegranych</i></h5>
                <p className={styles.competitionDescription}>Podobny do systemu pucharowego,
                    z tą różnicą, że po pierwszej przegranej gracze otrzymują drugą szansę na wygranie nawet całego
                    turnieju. Po drugiej porażce
                    zawodnik kończy swój udział w zawodach.
                </p>

                <h5>3a. <i>Brazylijski szybki</i></h5>
                <p className={styles.competitionDescription}>
                    Wariant systemu brazylijskiego przyspieszający przebieg turniejów jednodniowych. Topologia
                    drabinki jest taka sama (dwie przegrane = koniec udziału), z dwiema istotnymi zmianami:
                </p>
                <ul className={styles.competitionDescription}>
                    <li>
                        <strong>Pominięcie powtórzonego pojedynku:</strong> jeżeli ci sami zawodnicy mieliby zagrać
                        ze sobą po raz drugi w turnieju (typowo: w finale lub w drabince przegranych), drugi mecz
                        się nie odbywa — automatycznie awansuje zwycięzca poprzedniego spotkania. W drabince
                        widoczna jest etykieta „(bez gry)" zamiast wyniku, a ELO za taki mecz nie jest naliczane
                        (gracze zostali już rozliczeni przy pierwszym pojedynku).
                    </li>
                    <li>
                        <strong>Format meczu pro-set:</strong> niezależnie konfigurowalny per turniej —
                        jeden long-set rozgrywany do 9 gemów; przy stanie 8:8 rozgrywany jest tiebreak
                        do 7 punktów z 2-punktową przewagą (zwycięski wynik seta 9:8). Skraca pojedyncze mecze
                        i czyni wyrównane spotkania bardziej dynamicznymi w porównaniu do best-of-3 z super-tiebreakiem.
                    </li>
                </ul>

                <h5>4. <i>Faza grupowa + faza finałowa</i></h5>
                <p className={styles.competitionDescription}>
                    Turniej rozpoczyna się fazą grupową, w której uczestnicy grają w grupach każdy z każdym.
                    Dwóch najlepszych z każdej grupy awansuje do fazy finałowej, gdzie grają w systemie pucharowym.
                </p>

                <h5>5. <i>Liga grupowa</i></h5>
                <p className={styles.competitionDescription}>
                    Długoterminowe rozgrywki ligowe z podziałem na grupy (A, B, C...).
                    W każdej rundzie zawodnicy w grupie grają systemem każdy z każdym.
                    Po zakończeniu rundy najlepsi awansują do wyższej grupy, a najsłabsi spadają do niższej.
                </p>
                {/* ============================================================ */}
                {/* A. PUNKTACJA W GRUPIE                                         */}
                {/* ============================================================ */}
                <p className={styles.competitionDescription}><strong>A. Punktacja w grupie</strong></p>
                <p className={styles.competitionDescription}>Systemy naliczania punktów za pojedynczy mecz:</p>
                <li><strong>System klasyczny:</strong> wygrana = 2 pkt, przegrana = 0 pkt.</li>
                <li><strong>System 3-2-1-0:</strong> dominująca wygrana (różnica setów ≥ 2) = 3 pkt dla zwycięzcy, 0 dla przegranego.
                    Ciasna wygrana (różnica setów = 1) = 2 pkt dla zwycięzcy, 1 pkt dla przegranego.</li>
                <li><strong>Bonus za rozegranie meczu:</strong> +0.3 pkt dla obu graczy za każdy rozegrany mecz (nie dotyczy walkowerów; w przypadku kontuzji bonus jest przyznawany, bo mecz był rozegrany częściowo).</li>

                <p className={styles.competitionDescription}><strong>Kolejność rozstrzygania remisów w grupie (2 graczy):</strong></p>
                <li>Wynik bezpośredniego meczu między nimi</li>
                <li>Bilans setów w bezpośrednim meczu</li>
                <li>Bilans gemów w bezpośrednim meczu</li>
                <li>Globalny bilans setów (ze wszystkich meczów w grupie)</li>
                <li>Globalny bilans gemów (ze wszystkich meczów w grupie)</li>

                <p className={styles.competitionDescription}><strong>Kolejność rozstrzygania remisów w grupie (3+ graczy):</strong></p>
                <li>Mini-liga: bilans setów tylko z meczów między remisującymi graczami</li>
                <li>Mini-liga: bilans gemów tylko z meczów między remisującymi graczami</li>
                <li>Globalny bilans setów (ze wszystkich meczów w grupie)</li>
                <li>Globalny bilans gemów (ze wszystkich meczów w grupie)</li>

                {/* ============================================================ */}
                {/* B. RANKING OGÓLNY                                             */}
                {/* ============================================================ */}
                <p className={styles.competitionDescription}><strong>B. Ranking ogólny — trzy elementy wkładu rundy</strong></p>
                <p className={styles.competitionDescription}>
                    Ranking ogólny sumuje wkłady gracza ze wszystkich rund. Wkład z każdej rundy składa się z trzech równorzędnych elementów zdobywanych w jego grupie:
                </p>
                <li><strong>1. Punkty meczowe (średnia za mecz):</strong> suma punktów za mecze w grupie (system klasyczny lub 3-2-1-0, z bonusem 0.3 za każdy rozegrany mecz) podzielona przez liczbę meczów zaplanowanych dla gracza w tej rundzie.
                    Dzięki uśrednianiu aktywny gracz w grupie z zamrożonym rywalem nie traci względem pełnej grupy, a gracze w grupach różnej wielkości są porównywalni — liczy się średnia efektywność, nie liczba rozegranych meczów.</li>
                <li><strong>2. Premia grupowa:</strong> stała baza punktowa per grupa — im wyższa grupa, tym większa wartość (konfigurowalna).
                    Gracz otrzymuje ją proporcjonalnie do liczby rozegranych meczów względem zaplanowanych dla niego w tej rundzie.
                    Jeśli rywal jest zamrożony, plan gracza się zmniejsza — gracz nadal może otrzymać 100% premii grając wszystkie swoje mecze.
                    <em> Premia jest naliczana z grupy, w której gracz faktycznie grał w danej rundzie — nie z grupy, w której obecnie się znajduje.</em></li>
                <li><strong>3. Premia za miejsce w grupie (top-3):</strong> procentowy bonus od sumy (punkty meczowe + premia grupowa),
                    przyznawany wyłącznie za 3 pierwsze miejsca — niezależnie od rozmiaru grupy. Krok procentowy konfigurowany per grupa (domyślnie 5%).
                    Przy kroku 5%: 1. miejsce +15%, 2. +10%, 3. +5%, 4. i dalej 0%. Przy kroku 10%: odpowiednio +30%, +20%, +10%.
                    Przy remisie — oboje zremisowani dostają wyższą z dostępnych wartości.</li>
                <li><strong>Wzór wkładu rundy:</strong> <code>(punkty meczowe + premia grupowa) × (1 + % premii miejsca)</code>.
                    Ranking ogólny to suma wkładów ze wszystkich rund, plus ewentualna kompensacja za rundy zamrożone (patrz sekcja C).</li>

                <p className={styles.competitionDescription}><strong>Kolejność rozstrzygania remisów w rankingu ogólnym:</strong></p>
                <li>Suma punktów (mecze + premia grupowa + premia za miejsce + kompensacja zamrożeń)</li>
                <li>Bezpośrednie mecze między zawodnikami (ze wszystkich rund)</li>
                <li>Bilans setów w bezpośrednich meczach</li>
                <li>Łączna liczba wygranych</li>
                <li>Bilans wygranych i przegranych</li>
                <li>Liczba rozegranych meczów</li>

                {/* ============================================================ */}
                {/* C. ZAMROŻENIA                                                 */}
                {/* ============================================================ */}
                <p className={styles.competitionDescription}><strong>C. Zamrożenie udziału</strong></p>
                <p className={styles.competitionDescription}>
                    Gracz uczestniczący w lidze może zamrozić swój udział na 1 rundę (np. z powodu wakacji lub spraw osobistych).
                    Zamrożenie zgłasza się w trakcie bieżącej rundy — obowiązuje od następnej.
                </p>
                <li><strong>Limit:</strong> maksymalna liczba zamrożeń na sezon jest konfigurowana przez admina (domyślnie 2).</li>
                <li><strong>Widoczność:</strong> zamrożony gracz jest widoczny w tabeli grupowej ze znacznikiem &#10052;&#65039;, ale nie gra meczów i zdobywa 0 punktów za rundę.</li>
                <li><strong>Awanse i spadki:</strong> gracz zamrażający się uczestniczy normalnie w awansach/spadkach na podstawie wyników bieżącej rundy — po awansie/spadku trafia do docelowej grupy i tam jest zamrożony.
                    Gracze aktualnie zamrożeni (nie grali w rundzie) nie liczą się do puli.
                    Transfery między grupami są symetryczne — jeśli sąsiednia grupa nie ma aktywnych graczy, nikt nie awansuje ani nie spada na tej granicy.</li>
                <li><strong>Odmrożenie:</strong> po 1 rundzie gracz jest automatycznie odmrażany i wraca do gry. Można też odwołać zamrożenie przed startem kolejnej rundy.</li>
                <li><strong>Kompensacja w rankingu ogólnym:</strong> za każdą zamrożoną rundę gracz otrzymuje <em>kompensację</em> w wysokości określonego procenta <strong>średniej z rund, w których faktycznie grał</strong> (konfigurowalne globalnie, domyślnie 70%).
                    Średnia jest przeliczana po każdej nowej rozegranej rundzie, więc wartość kompensacji aktualizuje się dynamicznie.
                    Dzięki temu zamrożenie nadal kosztuje (gracz traci ~30% wartości tej rundy), ale nie skreśla go z walki o ranking.
                    Pozostali w jego grupie otrzymują pełną premię grupową grając swoje mecze.</li>
                <li><strong>Seria zwycięstw:</strong> zamrożenie nie przerywa serii — jest kontynuowana po odmrożeniu.</li>

                {/* ============================================================ */}
                {/* D. WYRÓŻNIENIA LIGOWE                                         */}
                {/* ============================================================ */}
                <p className={styles.competitionDescription}><strong>D. Wyróżnienia ligowe</strong></p>
                <p className={styles.competitionDescription}>
                    Niezależnie od rankingu ogólnego, przyznawane są wyróżnienia indywidualne obejmujące wszystkie grupy i rundy.
                    Walkowery i kontuzje nie są uwzględniane w statystykach.
                </p>
                <li><strong>Najwięcej wygranych</strong> — łączna liczba wygranych meczów</li>
                <li><strong>Najdłuższa seria</strong> — kolejne wygrane z rzędu (przez wszystkie rundy)</li>
                <li><strong>Bilans gemów</strong> — różnica gemów wygranych i przegranych</li>
                <li><strong>Najwyższy % wygranych</strong> — procent wygranych meczów (min. 3 mecze)</li>
                <li><strong>Bilans setów</strong> — różnica setów wygranych i przegranych</li>
                <li><strong>Wygrane tiebreaki</strong> — liczba wygranych tiebreakowych setów</li>
                <li><strong>Najbardziej dominujący</strong> — mecze wygrane 2:0 w setach</li>
                <li><strong>Król powrotów</strong> — mecze wygrane po przegranym pierwszym secie</li>
                <li><strong>Wojownik</strong> — najwięcej rozegranych tiebreakowych setów</li>

                <br/>
                <br/>

                <h5><i>Ilość meczów w turnieju jednodniowym w zależności od liczby graczy i wybranego systemu</i></h5>
                <p className={styles.competitionDescription}>
                    Poniższa tabela prezentuje ilość meczów, które należy rozegrać w turnieju dla wybranego systemu rozgrywek.
                    Druga liczba wskazuje na minimalną ilość meczów, którą zawodnik winien zagrać aby osiągnąć mecz finałowy.
                </p>

                <div className={styles.imageContainer}>
                </div>
                <div className={styles.tableWrapper}>
                    <table className={styles.systemsTable}>
                        <thead>
                        <tr>
                            <th>Liczba <br/>graczy</th>
                            <th>Każdy z <br/>każdym</th>
                            <th>Pucharowy</th>
                            <th>Brazylijski</th>
                            <th>Brazylijski <br/>szybki</th>
                            <th>Grupa+<br/>finał</th>
                            <th>Liczba <br/>grup</th>
                        </tr>
                        </thead>
                        <tbody>
                        {[
                            [4, '6\n3', '4\n2', '-', '-', '-', '-'],
                            [5, '10\n4', '5\n2', '-', '-', '-', '-'],
                            [6, '15\n5', '6\n2', '10\n3', '8\n2', '10\n4', 2],
                            [7, '21\n6', '7\n2', '12\n3', '10\n2', '13\n4', 2],
                            [8, '28\n7', '8\n3', '14\n4', '12\n3', '16\n5', 2],
                            [9, '36\n8', '9\n3', '16\n4', '15\n3', '15\n4', 3],
                            [10, '45\n9', '10\n3', '18\n4', '17\n3', '18\n4', 3],
                            [11, '55\n10', '11\n3', '20\n4', '19\n3', '21\n4', 3],
                            [12, '66\n11', '12\n3', '22\n4', '21\n3', '20\n5', 4],
                            [13, '78\n12', '13\n3', '24\n4', '23\n3', '23\n5', 4],
                            [14, '91\n13', '14\n3', '26\n5', '25\n4', '26\n5', 4],
                            [15, '105\n14', '15\n3', '28\n5', '27\n4', '29\n5', 4],
                            [16, '120\n15', '16\n4', '30\n5', '29\n4', '32\n6', 4]
                        ].map((row, idx) => (
                            <tr key={idx}>
                                {row.map((cell, i) => (
                                    <td key={i}>
                                        {typeof cell === 'string' ? (
                                            cell.split('\n').map((line, index) => (
                                                <div key={index}>{line}</div>
                                            ))
                                        ) : cell}
                                    </td>
                                ))}
                            </tr>
                        ))}
                        </tbody>
                    </table>

                    <p className={styles.tableNote}>
                        <strong>Legenda:</strong><br/>
                        Pierwsza liczba – łączna liczba meczów<br/>
                        Druga liczba – najkrótsza droga do finału
                    </p>
                </div>


            </div>
        </div>
    );
};

export default CompetitionSystemsDescription;
